var _linearGradient, _path, _path2, _linearGradient2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _g, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Toolbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "CC9oZZMzjsmibQMmvMyOwa",
    x1: 24,
    x2: 24,
    y1: 17.053,
    y2: 40.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#c71926"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#b51623"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886,
    stopColor: "#9c131f"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CC9oZZMzjsmibQMmvMyOwa)",
    d: "M4,17h40v21c0,1.105-0.895,2-2,2H6c-1.105,0-2-0.895-2-2V17z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#eb6773",
    d: "M44,17v-3.172c0-0.53-0.211-1.039-0.586-1.414l-1.828-1.828C41.211,10.211,40.702,10,40.172,10H7.828 c-0.53,0-1.039,0.211-1.414,0.586l-1.828,1.828C4.211,12.789,4,13.298,4,13.828V17H44z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "CC9oZZMzjsmibQMmvMyOwb",
    x1: 16,
    x2: 32,
    y1: 8.5,
    y2: 8.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5e5e5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#545454"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CC9oZZMzjsmibQMmvMyOwb)",
    d: "M30.5,7h-13C16.672,7,16,7.672,16,8.5V10h16V8.5C32,7.672,31.328,7,30.5,7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37,21.909h-2c-1.054,0-1.909-0.855-1.909-1.909v-4c0-1.054,0.855-1.909,1.909-1.909h2 c1.054,0,1.909,0.855,1.909,1.909v4C38.909,21.054,38.054,21.909,37,21.909z",
    opacity: 0.018
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37,21.818h-2c-1.004,0-1.818-0.814-1.818-1.818v-4c0-1.004,0.814-1.818,1.818-1.818h2 c1.004,0,1.818,0.814,1.818,1.818v4C38.818,21.004,38.004,21.818,37,21.818z",
    opacity: 0.036
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37,21.727h-2c-0.954,0-1.727-0.773-1.727-1.727v-4c0-0.954,0.773-1.727,1.727-1.727h2 c0.954,0,1.727,0.773,1.727,1.727v4C38.727,20.954,37.954,21.727,37,21.727z",
    opacity: 0.054
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37,21.636h-2c-0.904,0-1.636-0.733-1.636-1.636v-4c0-0.904,0.733-1.636,1.636-1.636h2 c0.904,0,1.636,0.733,1.636,1.636v4C38.636,20.904,37.904,21.636,37,21.636z",
    opacity: 0.073
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37,21.545h-2c-0.854,0-1.545-0.692-1.545-1.545v-4c0-0.854,0.692-1.545,1.545-1.545h2 c0.854,0,1.545,0.692,1.545,1.545v4C38.545,20.854,37.854,21.545,37,21.545z",
    opacity: 0.091
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37,21.455h-2c-0.803,0-1.455-0.651-1.455-1.455v-4c0-0.803,0.651-1.455,1.455-1.455h2 c0.803,0,1.455,0.651,1.455,1.455v4C38.455,20.803,37.803,21.455,37,21.455z",
    opacity: 0.109
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M37,21.364h-2c-0.753,0-1.364-0.611-1.364-1.364v-4c0-0.753,0.611-1.364,1.364-1.364h2 c0.753,0,1.364,0.611,1.364,1.364v4C38.364,20.753,37.753,21.364,37,21.364z",
    opacity: 0.127
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M37,21.273h-2c-0.703,0-1.273-0.57-1.273-1.273v-4c0-0.703,0.57-1.273,1.273-1.273h2 c0.703,0,1.273,0.57,1.273,1.273v4C38.273,20.703,37.703,21.273,37,21.273z",
    opacity: 0.145
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37,21.182h-2c-0.653,0-1.182-0.529-1.182-1.182v-4c0-0.653,0.529-1.182,1.182-1.182h2 c0.653,0,1.182,0.529,1.182,1.182v4C38.182,20.653,37.653,21.182,37,21.182z",
    opacity: 0.164
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M37,21.091h-2c-0.602,0-1.091-0.488-1.091-1.091v-4c0-0.602,0.488-1.091,1.091-1.091h2 c0.602,0,1.091,0.488,1.091,1.091v4C38.091,20.602,37.602,21.091,37,21.091z",
    opacity: 0.182
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37,21h-2c-0.552,0-1-0.448-1-1v-4c0-0.552,0.448-1,1-1h2c0.552,0,1,0.448,1,1v4 C38,20.552,37.552,21,37,21z",
    opacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13,21.909h-2c-1.054,0-1.909-0.855-1.909-1.909v-4c0-1.054,0.855-1.909,1.909-1.909h2 c1.054,0,1.909,0.855,1.909,1.909v4C14.909,21.054,14.054,21.909,13,21.909z",
    opacity: 0.018
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,21.818h-2c-1.004,0-1.818-0.814-1.818-1.818v-4c0-1.004,0.814-1.818,1.818-1.818h2 c1.004,0,1.818,0.814,1.818,1.818v4C14.818,21.004,14.004,21.818,13,21.818z",
    opacity: 0.036
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,21.727h-2c-0.954,0-1.727-0.773-1.727-1.727v-4c0-0.954,0.773-1.727,1.727-1.727h2 c0.954,0,1.727,0.773,1.727,1.727v4C14.727,20.954,13.954,21.727,13,21.727z",
    opacity: 0.054
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,21.636h-2c-0.904,0-1.636-0.733-1.636-1.636v-4c0-0.904,0.733-1.636,1.636-1.636h2 c0.904,0,1.636,0.733,1.636,1.636v4C14.636,20.904,13.904,21.636,13,21.636z",
    opacity: 0.073
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,21.545h-2c-0.854,0-1.545-0.692-1.545-1.545v-4c0-0.854,0.692-1.545,1.545-1.545h2 c0.854,0,1.545,0.692,1.545,1.545v4C14.545,20.854,13.854,21.545,13,21.545z",
    opacity: 0.091
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,21.455h-2c-0.803,0-1.455-0.651-1.455-1.455v-4c0-0.803,0.651-1.455,1.455-1.455h2 c0.803,0,1.455,0.651,1.455,1.455v4C14.455,20.803,13.803,21.455,13,21.455z",
    opacity: 0.109
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,21.364h-2c-0.753,0-1.364-0.611-1.364-1.364v-4c0-0.753,0.611-1.364,1.364-1.364h2 c0.753,0,1.364,0.611,1.364,1.364v4C14.364,20.753,13.753,21.364,13,21.364z",
    opacity: 0.127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,21.273h-2c-0.703,0-1.273-0.57-1.273-1.273v-4c0-0.703,0.57-1.273,1.273-1.273h2 c0.703,0,1.273,0.57,1.273,1.273v4C14.273,20.703,13.703,21.273,13,21.273z",
    opacity: 0.145
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,21.182h-2c-0.653,0-1.182-0.529-1.182-1.182v-4c0-0.653,0.529-1.182,1.182-1.182h2 c0.653,0,1.182,0.529,1.182,1.182v4C14.182,20.653,13.653,21.182,13,21.182z",
    opacity: 0.164
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,21.091h-2c-0.602,0-1.091-0.488-1.091-1.091v-4c0-0.602,0.488-1.091,1.091-1.091h2 c0.602,0,1.091,0.488,1.091,1.091v4C14.091,20.602,13.602,21.091,13,21.091z",
    opacity: 0.182
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,21h-2c-0.552,0-1-0.448-1-1v-4c0-0.552,0.448-1,1-1h2c0.552,0,1,0.448,1,1v4 C14,20.552,13.552,21,13,21z",
    opacity: 0.2
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M35,15h2c0.552,0,1,0.448,1,1v4c0,0.552-0.448,1-1,1h-2c-0.552,0-1-0.448-1-1v-4 C34,15.448,34.448,15,35,15z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11,15h2c0.552,0,1,0.448,1,1v4c0,0.552-0.448,1-1,1h-2c-0.552,0-1-0.448-1-1v-4 C10,15.448,10.448,15,11,15z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Toolbox);
export default __webpack_public_path__ + "static/media/icons8-toolbox.73e99bb6c04fc181f5f1f4a3c5c8dfe0.svg";
export { ForwardRef as ReactComponent };